import { useCompanyStructureAll } from "@/modules/common/entities/company-structure/select/model/use-company-structure-all";
import { useCompanyStructureFromNode } from "@/modules/common/entities/company-structure/select/model/use-company-structure-from-node";
import { HierarchyElementType } from "gql/graphql";

export function useCompanyStructureData({
  fromNodeId,
  types,
}: {
  fromNodeId?: string;
  types?: HierarchyElementType[];
}) {
  const { nodes: allNodes, loading: loadingAllNodes } = useCompanyStructureAll({
    types,
    skip: !!fromNodeId,
  });

  const { nodes: nodesFromNode, loading: loadingNodesFromNode } =
    useCompanyStructureFromNode({
      id: fromNodeId,
      types,
    });

  const nodes = nodesFromNode.length > 0 ? nodesFromNode : allNodes;
  const loading = loadingNodesFromNode ?? loadingAllNodes;

  return {
    nodes,
    loading,
  };
}
